import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import TableView from "./tableView";
import { connect } from 'react-redux'
import { getAPi } from '../../api/api'
import Loader from "../../reusableComponents/loader/Loader";
import moment from "moment";
import { fetchGetUnitDetails, fetchGetHuntDetails } from "../../../../action/huntPlanner-unitdetails-actions";
import { stopLoading } from "../../../../action/huntPlanner-load-spinner-action";
import HuntGraph from "./hunt-graph/huntGraph";
import UpgradeButton from "./upgrade-button";
import Locktext from "./locktext";
import LockIcon from '../../../../../asset/lock.png'
import LoadImage from "./loadImage";

const HuntDetails = (props) => {
  const [huntDetails, setHuntDetails] = useState([])
  const [spinLoader, setSpinLoader] = useState(true)
  const [firstRaisedOdds, setfirstRaisedOdds] = useState(null)
  const [unitDetails, setUnitDetails] = useState(props.unitDetails)
  const [harvestData, setHarvestData] = useState([])
  const prevUnitData = useRef(null);
  const [drawodds, setDrawodds] = useState(null)

  useEffect(() => {
    props.stopLoading();
    if (JSON.stringify(prevUnitData.current) !== JSON.stringify(props.unitData)) {
      fetchHuntData(props.unitData);
      prevUnitData.current = props.unitData;
    }
    if (props.from === 'hunt') {
      fetchUnitData(props.huntPlannerSelectedOtions);
    }
    let drawodds = props.unitData.minPoints && JSON.parse(props.unitData.minPoints)
    let drawoddsm = props.unitData.minPoint && JSON.parse(props.unitData.minPoint)
    setDrawodds(drawodds || drawoddsm)

  }, [props.unitData, props.from, props.huntPlannerSelectedOtions]);

  useEffect(() => {
    if (props.location == 'menu') {
      props.renderLayerUnit(true)
    }

  }, []);

  let closeUnit = () => {
    if (props.from != 'hunt')
      props.closeTheUnit()
    else
      props.closeTheCard()
  }

  let closeHunt = () => {
    props.closeTheCard()
  }

  let fetchUnitData = (payloadData) => {
    let unitName = props.unitDetails.unitName || props.unitDetails.geoName
    let payload = {
      ...payloadData,
      webHuntId: props.unitData.webHuntId,
      unitName: props.unitDetails.unitName || props.unitDetails.geoName
    };
    if (unitName) {
      props.fetchGetUnitDetails(payload)
        ?.then((res) => {
          setUnitDetails(res)
        })
        .catch((error) => {
          console.error('API Error:', error);
        });
    }
  }

  const formatDate = (dateString) => {
    // Check if it's already in ISO format
    let val = moment(dateString, moment.ISO_8601, true).isValid()
      ? moment(dateString).format("MM-DD-YYYY")
      : moment(dateString, "M/D/YYYY").format("MM-DD-YYYY");
    return val;
  };

  const formatDateName = (dateString) => {
    if (!dateString) return "-"; // Handle missing dates

    const date = new Date(dateString.includes("T") ? dateString : dateString + "T00:00:00Z"); // Fix Safari issue

    const formattedDate = isNaN(date.getTime())
      ? "Invalid Date"
      : date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    return formattedDate;
  };


  let fetchHuntData = (payloadData) => {
    let payload = {
      huntTypeKey: props.huntPlannerSelectedOtions.HuntTypeKey,
      Species: props.huntPlannerSelectedOtions.Species,
      StateAbbreviation: props.huntPlannerSelectedOtions.StateAbbreviation,
      drawId: payloadData.drawId,
      otcId: payloadData.otcId,
      webHuntId: payloadData.webHuntId,
      drawChoice: props.huntPlannerSelectedOtions.DrawChoice,
      DrawPercentage: props.huntPlannerSelectedOtions.DrawPercentage,
      unitName: props.unitNameRelatedData.unitName ? props.unitNameRelatedData.unitName : props.unitNameRelatedData.geoName
    };

    props.fetchGetHuntDetails(payload)
      ?.then((res) => {
        if (res) {
          setHuntDetails(res)
          setHarvestData(res.huntTrends)
        }
        setSpinLoader(false)
        props.stopLoading();

        let oddsdata = res?.oddsByPoints || [];  // Ensure it's an array
        if (false) {
          // if (props.huntplannerMorefilters.DrawPercentage) {
          // setfirstRaisedOdds(+props.huntplannerMorefilters.DrawPercentage);
        }
        else {
          if (Array.isArray(oddsdata) && oddsdata.length > 0) {
            // Try to find the exact match first
            let firstRaisedOdds = oddsdata.find(item => item.point == props.huntplannerMorefilters.DrawPoints);

            // If not found, fall back to point == 0
            if (!firstRaisedOdds) {
              firstRaisedOdds = oddsdata.find(item => item.point == 0);
            }

            // Then set the odds from the found object (if any)
            if (firstRaisedOdds) {
              setfirstRaisedOdds(+firstRaisedOdds.odds);
            }

            if (firstRaisedOdds) {
              setfirstRaisedOdds(+firstRaisedOdds?.odds);
              console.log("First raised odds:", firstRaisedOdds);
            } else {
              console.log("No raised odds found.");
            }
          } else {
            console.log("oddsdata is empty or not an array.");
          }
        }
      })
      .catch((error) => {
        setSpinLoader(false);
        console.error('API Error:', error);
      });
  }

  return (
    <>
      {spinLoader && <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>}
      <div className="unit-details-container">
        <div className="back-arrow-div">
          <img onClick={closeUnit} src={require('../../../../../asset/Close-X_Thin_F2F2F2_SVG.svg')} className="back-arrow-style" style={{ height: 20 }}></img>
        </div>

        {unitDetails && (
          <div className="unit-details-container-two">
            <div className="unit-details-header">
              <h3 className="unit-title">Unit: {unitDetails.geoName || unitDetails.unitName}</h3>
            </div>
            <div className="unit-metrics">
              <div className="stat">
                <Locktext
                  LockIcon={LockIcon}
                  text={unitDetails.unitScore}
                  showText={props.huntPlannerFilterOptions?.huntResearch}
                />
                <div className="progress">
                  <div
                    className={`progress-bar ${unitDetails.unitScore <= 33 ? 'red' : unitDetails.unitScore <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${unitDetails.unitScore ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Unit Score</p>
              </div>
              <div className="partition-line"></div>

              <div className="stat">
                <Locktext
                  LockIcon={LockIcon}
                  text={(unitDetails.trophy ? unitDetails.trophy + '"' : "-")}
                  showText={props.huntPlannerFilterOptions?.huntResearch}
                />
                <div className="progress">
                  <div
                    className={`progress-bar ${unitDetails?.trophy <= 33 ? 'red' : unitDetails?.trophy <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${unitDetails?.trophy ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Trophy</p>
              </div>

              <div className="partition-line"></div>

              <div className="stat">
                <div className='stat' style={{ width: '100%', height: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <span className="metric-value font-style-roboto">
                    {unitDetails.publicLand !== undefined ? `${unitDetails.publicLand}%` : "-"}
                  </span>
                </div>
                <div className="progress">
                  <div
                    className={`progress-bar ${unitDetails?.publicLand <= 33 ? 'red' : unitDetails?.publicLand <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${unitDetails?.publicLand ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Public Land</p>
              </div>
            </div>
          </div>
        )}

      </div>
      <div className="unit-hunt-card-item">
        {huntDetails && (
          <>
            {!props.huntPlannerFilterOptions?.huntResearch && <UpgradeButton className={'upgrade-button-style'} />}
            {props.from != 'hunt' && <div className="back-arrow-to-unit-div">
              <img onClick={closeHunt} src={require('../../../../../asset/Arrow-Left_Med_808080.svg')} className="back-arrow-style" style={{ width: 15, height: 20 }}></img>
            </div>}

            <div key={huntDetails?.webHuntId} className="hunt-card-detail" style={{ width: '100%' }} >
              <div className="ut-ht-options-container-one">
                {huntDetails?.sex || huntDetails?.startDate || huntDetails.applyFor ?
                  <>
                    <div className="one" style={{ height: '80%' }}>
                      <p className="date">
                        {`${formatDateName(huntDetails?.startDate)} - ${formatDateName(huntDetails?.endDate)}`}
                      </p>
                      <div style={{ display: 'flex', marginTop: 10, marginBottom: '10px' }}>
                        <p className="oswald-medium" style={{ color: '#1D1D1D' }}>Sex :</p>
                        <p className={`either ${huntDetails?.sex == 'female' ? 'red' : 'orange'}`}> {huntDetails?.sex}</p>
                      </div>
                      {huntDetails.applyFor && <p className="apply-for">Apply for: <span className="apply-for-ans">{huntDetails.applyFor}</span></p>}
                    </div>

                    <div className="two" style={{ height: '55%' }}>
                      <LoadImage imageProfileUrl={huntDetails?.weaponIconUrl} defaultImage={'../../asset/defaultweaponicon.png'}></LoadImage>
                    </div>
                  </>
                  : null
                }
              </div>

              {huntDetails?.sex || huntDetails?.startDate || huntDetails.applyFor ?
                <div className="ut-ht-options-container-two" style={{ height: '60%' }}>
                  <div className="unit-metrics" style={{ width: '100%' }}>
                    <div className="stat" style={{ width: '30%' }}>
                      <Locktext
                        LockIcon={LockIcon}
                        text={drawodds?.point}
                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                        textClass='green'
                        className={'font-style-oswald-medium'}
                      />
                      <div className="progress">
                        <div
                          className={`progress-bar`}
                          style={{ width: `${drawodds?.point ?? 0}%` }}
                        ></div>
                      </div>
                      <p className="label">Min Points to draw</p>
                    </div>

                    <div className="partition-line" style={{ height: '50%', marginTop: 15 }}></div>

                    <div className="stat" style={{ width: '30%' }}>
                      <Locktext
                        LockIcon={LockIcon}
                        text={(drawodds?.odds ? drawodds?.odds.toFixed(0) : "-")}
                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                        showColorText={true}
                        showPercentage={true}
                        className={'font-style-oswald-medium'}
                      />

                      <div className="progress">
                        <div
                          className={`progress-bar ${!props?.huntPlannerFilterOptions?.huntResearch ? 'grey' : drawodds?.odds <= 33 ? 'red' : drawodds?.odds <= 66 ? 'yellow' : 'green'}`}
                          style={{ width: `${drawodds?.odds ?? 0}%` }}
                        ></div>
                      </div>

                      <p className="label">Draw odds 1st choice</p>
                    </div>

                    <div className="partition-line" style={{ height: '50%', marginTop: 15 }}></div>

                    <div className="stat" style={{ width: '30%' }}>

                      <Locktext
                        LockIcon={LockIcon}
                        text={props.unitData?.harvestSuccess !== undefined ? `${props.unitData?.harvestSuccess.toFixed(0)}` : props.unitData?.success ? `${props.unitData?.success.toFixed(0)}` : "-"}
                        showText={props?.huntPlannerFilterOptions?.huntResearch}
                        showColorText={true}
                        showPercentage={true}
                        className={'font-style-oswald-medium'}
                      />

                      {/* <div className='stat' style={{ width: '100%', height: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <span className={`metric-value font-style-oswald-medium ${props.unitData?.harvestSuccess <= 33 ? 'red' : props.unitData?.harvestSuccess <= 66 ? 'yellow' : 'green'}`}>
                          {props.unitData?.harvestSuccess !== undefined ? `${props.unitData?.harvestSuccess.toFixed(0)}%` : props.unitData?.success ? `${props.unitData?.success.toFixed(0)}%` : "-"}
                        </span>
                      </div> */}

                      <div className="progress">
                        <div
                          className={`progress-bar ${!props?.huntPlannerFilterOptions?.huntResearch ? 'grey' : props.unitData.harvestSuccess <= 33 ? 'red' : props.unitData.harvestSuccess <= 66 ? 'yellow' : 'green'}`}
                          style={{ width: `${props.unitData.harvestSuccess ?? props.unitData.success ?? 0}%` }}
                        ></div>
                      </div>
                      <p className="label" >Harvest success</p>
                    </div>
                  </div>
                </div>
                :
                null
              }
            </div>

            {props.huntPlannerFilterOptions?.huntResearch && huntDetails.oddsByPoints?.length > 0 ?
              (
                <div className="draw-odds">
                  <h4>Draw Odds</h4>
                  <div className="draw-odds-container">
                    <p className="draw-odds-item-p">Your Points : {props.huntplannerMorefilters?.DrawPoints || 0} </p>
                    <p className="draw-odds-description">Edit your points in the hunt filters</p>
                    {huntDetails.oddsByPoints?.length > 0 && <TableView tableData={huntDetails.oddsByPoints} />}
                    <div className="odds">
                      <p className="draw-odds-item-p">Your draw odds:</p>
                      <p className={`odds-percentage ${firstRaisedOdds <= 33 ? 'red' : firstRaisedOdds <= 66 ? 'yellow' : 'green'}`}>
                        {firstRaisedOdds != null ? firstRaisedOdds.toFixed(0) + '%' : '0%'}


                      </p>
                    </div>
                    {/*
                     <div className="odds-chart-history">
                      <p>1st choice with {props.huntplannerMorefilters?.DrawPoints || 0} points</p>
                    </div> 
                    */}
                  </div>
                </div>
              )
              :
              (
                harvestData && harvestData[0]?.pointGraphUrl &&
                (
                  <div>
                    <img
                      style={{ width: "100%" }}
                      src={harvestData[0].pointGraphUrl}
                      alt="Sample Preference Point Graph"
                    />
                  </div>
                )
              )
            }

            {props.huntPlannerFilterOptions?.huntResearch && harvestData.length > 0 ?
              (
                <div className="graph-container">
                  <HuntGraph harvestData={harvestData} />
                </div>
              )
              :
              (
                harvestData && harvestData[0]?.harvestGraphUrl && (
                  <div>
                    <img
                      style={{ width: "100%" }}
                      src={harvestData[0].harvestGraphUrl}
                      alt="Hunt Data Graph"
                    />
                  </div>
                )
              )
            }
          </>
        )}
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  auth: state.auth,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntPlannerLoader: state.huntPlannerLoader,
  currentSubscription: state.currentSubscription,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions,
  huntplannerMorefilters: state.huntplannerMorefilters

})

const mapDispatchToProps = dispatch => ({
  fetchGetUnitDetails: (payload) => dispatch(fetchGetUnitDetails(payload)),
  stopLoading: () => dispatch(stopLoading()),
  fetchGetHuntDetails: (payload) => dispatch(fetchGetHuntDetails(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntDetails)